import React, { Fragment } from "react";
import Calendar from "react-calendar";
import { PlusCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import IconButton from "../../../iconButton";
import CustomEventDropdown from "../../../dropdown/CustomEventDropdown";
import { useState } from "react";

const timeData = [
  {
    id: 1,
    time: "5:00 PM",
  },
  {
    id: 2,
    time: "6:00 PM",
  },
  {
    id: 3,
    time: "7:00 PM",
  },
];
const eventData = [
  {
    id: 1,
    name: "Zoom Call",
    color: "#D834A0",
  },
  {
    id: 2,
    name: "Planning Meeting",
    color: "#FFD912",
  },
  {
    id: 3,
    name: "Work Report",
    color: "#7D34D8",
  },
  {
    id: 4,
    name: "Important Announcement",
    color: "#D85B34",
  },
];
const membersData = [
  {
    id: 1,
    text: "Super Admins",
  },
  {
    id: 2,
    text: "Admins",
  },
  {
    id: 3,
    text: "Sales team",
  },
  {
    id: 4,
    text: "Sales team Manager",
  },
  {
    id: 5,
    text: "Support Team",
  },
  {
    id: 6,
    text: "Support Team Manager",
  },
];

const DashboardCalendarSlideOver = ({ show, setShowSlide, handleClose }) => {
  const [newEvent, setNewEvent] = useState();

  const handleCalendarEvent = () => {
    setNewEvent(true)
  };

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="">
                      <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                        <div className="flex items-center justify-between mb-2 md:mb-5">
                          <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                            Add New Event
                          </Dialog.Title>
                          <XMarkIcon
                            className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                            onClick={handleClose}
                          />
                        </div>
                        <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868]">
                          Creating a Calendar Event will automatically replicate
                          it across all associated team Google Calendars.
                        </p>
                      </div>
                      <div className="calender-wrapper">
                        <Calendar className="mb-5" />
                      </div>
                      <form className="scroller max-h-[220px] md:max-h-[300px] overflow-y-auto pr-1 mb-[30px] dark-field">
                        <div>
                          <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-4 inline-block">
                            Time
                          </label>
                          <CustomDropdown
                            options={timeData.map((data) => data.time)}
                            classes="px-[14px] md:p-5 border border-solid border-strokeColor rounded-[10px] h-12 md:h-[70px] bg-white flex items-center justify-between w-full mb-5"
                            textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-lg font-medium text-customGray"
                            rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
                            menuClasses="absolute left-0 z-10 mt-7 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                          />
                        </div>
                        <div>
                          <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-4 inline-block">
                            Type of Event
                          </label>
                          <CustomEventDropdown
                            newEvent={newEvent}
                            setNewEvent={setNewEvent}
                            handleEvent={handleCalendarEvent}
                            options={eventData}
                            classes="px-[14px] md:p-5 border border-solid border-strokeColor rounded-[10px] h-12 md:h-[70px] bg-white flex items-center justify-between w-full mb-5"
                            textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-lg font-medium text-customGray"
                            rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
                            menuClasses="absolute left-0 z-10 mt-7 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 border border-[#F1F4F6] focus:outline-none"
                          />
                        </div>
                        <div>
                          <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-4 inline-block">
                            Title
                          </label>
                          <input
                            className="text-sm md:text-lg font-bold leading-[160%] text-customGray py-[10px] px-3.5 md:px-5 h-12 md:h-[70px] border border-solid border-strokeColor rounded-md w-full mb-5"
                            placeholder="Title name"
                          />
                        </div>
                        <div>
                          <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-3 inline-block">
                            Description
                          </label>
                          <textarea
                            name="description"
                            className="text-sm md:text-lg leading-[160%] text-customGray px-[14px] md:px-7 py-5 border border-solid border-strokeColor rounded-[10px] mb-5 w-full min-h-[142px] md:min-h-[185px] resize-none outline-none placeholder:text-[#768B9F] placeholder:font-normal placeholder:text-base"
                            //   value={formik.values.about_me}
                            //   onChange={handleInputChange}
                            //   onBlur={formik.handleBlur}
                            placeholder="Description"
                          />
                        </div>
                        <div>
                          <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-5 inline-block">
                            Members
                          </label>
                          {membersData.map((item , index) => (
                            <div
                              className={`form-group relative flex items-center pl-1 transition-all duration-300 ease-in cursor-pointer mb-3`}
                              //   onClick={handleDivClick}
                              key={"member"+index}
                            >
                              <input
                                id={`option-${item.id}`}
                                aria-describedby="comments-description"
                                name={`option-${item.id}`}
                                type="checkbox"
                                // checked={isOptionSelected}
                                // onChange={handleCheckboxChange}
                                className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                              />
                              <div className="min-w-0 flex-1 text-sm leading-6">
                                <label
                                  htmlFor={`option-${item.id}`}
                                  className="font-medium text-customGray text-sm md:text-base leading-[160%] pl-[14px] cursor-pointer"
                                >
                                  {item.text}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </form>
                      <div>
                        <IconButton
                          title="add new event"
                          icon={PlusCircleIcon}
                          classes="mb-5 md:mb-0 flex items-center bg-primary text-sm md:text-base text-white rounded-[10px] font-black uppercase text-[#485868] leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer"
                          //   onClick={() => setShowCalendarSlideOver(true)}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default DashboardCalendarSlideOver;
